import loadView from "@/utils/load-view";

const routes = [
    {
        path: "/team/members",
        name: "UsersTeams",
        component: loadView("UsersTeams"),
        props: true,
        meta: {
            authRequired: true,
            resolvers: [
                () => ({ type: "teams/current/get", payload: { cache: true } }),
                () => ({ type: "teams/local/getList", payload: { filter: "all", cache: true } }),
                () => ({ type: "users/location/getList" }),
                () => ({ type: "teams/customrole/getList" }),
                to => {
                    if (to.query?.keepExistingList) {
                        return;
                    } else {
                        return { type: "users/list/get", payload: { offset: 0 } };
                    }
                },
            ],
        },
        children: [
            {
                path: "/team/members/add",
                name: "UsersTeamsAddUsers",
                component: loadView("UsersTeamsAddUsers"),
                meta: {
                    authRequired: true,
                },
            },
            {
                path: "/team/members/invite/:id",
                name: "UsersTeamsSendInvite",
                component: loadView("UsersTeamsSendInvite"),
                props: true,
                meta: {
                    authRequired: true,
                    resolvers: [
                        to => {
                            if (to.params.id !== "all") {
                                return {
                                    type: "users/details/get",
                                    payload: { id: to.params.id },
                                };
                            } else {
                                return {
                                    type: "teams/local/getList",
                                    payload: { filter: "all", cache: true },
                                };
                            }
                        },
                    ],
                },
            },
            {
                path: "/team/members/levels/:id",
                name: "UsersTeamsManageLevels",
                component: loadView("UsersTeamsManageLevels"),
                props: true,
                meta: {
                    authRequired: true,
                    resolvers: [
                        to => {
                            if (to.params.id !== "list") {
                                return {
                                    type: "teams/customrole/get",
                                    payload: { id: to.params.id },
                                };
                            } else {
                                return {
                                    type: "teams/customrole/getList",
                                };
                            }
                        },
                    ],
                },
            },
            {
                path: "/team/members/customAttributes/:id",
                name: "UsersTeamsManageCustomAttributes",
                component: loadView("UsersTeamsManageCustomAttributes"),
                props: true,
                meta: {
                    authRequired: true,
                    resolvers: [
                        to => {
                            if (to.params.id !== "list") {
                                return {
                                    type: "users/customAttribute/get",
                                    payload: { id: to.params.id },
                                };
                            } else {
                                return {
                                    type: "users/customAttribute/getList",
                                };
                            }
                        },
                    ],
                },
            },
            {
                path: "/team/members/teams/list",
                name: "UsersTeamsManageTeams",
                component: loadView("UsersTeamsManageTeams"),
                props: route => ({ ...route.params, id: "list" }),
                meta: {
                    authRequired: true,
                    resolvers: [
                        () => ({
                            type: "teams/local/getList",
                            payload: { filter: "allStacked" },
                        }),
                    ],
                },
            },
            {
                path: "/team/members/teams/new",
                name: "UsersTeamsManageTeams",
                component: loadView("UsersTeamsManageTeams"),
                props: route => ({ ...route.params, id: "new" }),
                meta: {
                    authRequired: true,
                },
            },
            {
                path: "/team/members/teams/:id",
                name: "UsersTeamsManageTeams",
                component: loadView("UsersTeamsManageTeams"),
                props: true,
                meta: {
                    authRequired: true,
                    resolvers: [
                        to => ({
                            type: "teams/local/get",
                            payload: { id: to.params.id },
                        }),
                    ],
                },
            },
            {
                path: "/team/members/user/:id",
                name: "UsersTeamsManageUser",
                component: loadView("UsersTeamsManageUser"),
                props: true,
                meta: {
                    authRequired: true,
                    resolvers: [
                        to => ({
                            type: "users/details/get",
                            payload: { id: to.params.id },
                        }),
                        () => ({ type: "users/location/getList" }),
                        () => ({ type: "teams/customrole/getList" }),
                    ],
                },
            },
        ],
    },
];

export default routes;
